export default __webpack_public_path__ + "static/media/wix-icon.0eaf0041.png";